export default __webpack_public_path__ + "static/media/icon-cancel-filled.28c88785.svg";